export const dropDownSearchValue = (array, value) => array.find((i) => i.value === value);
